/* eslint-disable import/prefer-default-export */
import { addDay, startOfDay } from '../utils/date';
import { easyPost } from './utils';

//  查询认证状态
export const getWechatUserInfo = ({
  openId, code, businessType, scope,
}) => easyPost('user.wechat.userInfo')({
  openId,
  code,
  businessType,
}).then((res) => {
  const storageKey = `${scope}wx_open_id_`;
  if (res && res.data && res.data.openid) {
    const expirationDate = startOfDay(addDay(new Date(), 19));
    Storage.setItem(storageKey, res.data.openid, expirationDate);
    return res.data;
  }
  throw new Error('获取userInfo失败');
});
